var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgRescan(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.5419 16.4383C12.8719 16.1086 13.3917 16.1085 13.7216 16.4383L20.0019 22.7186C20.5117 23.2486 20.1513 24.1483 19.4013 24.1483H14.7714C14.7714 30.3083 20.4022 35.1885 26.7822 33.8885C26.982 33.8086 27.2018 33.7586 27.4316 33.7586C28.3516 33.7586 29.1015 34.5085 29.1015 35.4285L29.1113 35.4383C29.1113 36.1983 28.5915 36.8389 27.8915 37.0389C27.7216 37.0789 27.5712 37.1388 27.4013 37.1688C18.8915 38.8085 11.4619 32.3381 11.4619 24.1483H6.83197C6.08197 24.1483 5.72189 23.2481 6.25189 22.7381L12.5419 16.4383ZM21.6122 11.2586C30.1222 9.60865 37.5522 16.0784 37.5322 24.2684H42.1621C42.9121 24.2684 43.2721 25.1685 42.7421 25.6785L36.4619 31.9783C36.1319 32.3081 35.6121 32.3082 35.2822 31.9783L29.0019 25.6981C28.4922 25.168 28.8526 24.2684 29.6025 24.2684H34.2324C34.2324 18.1085 28.6024 13.2285 22.2226 14.5281C22.0226 14.6081 21.8022 14.658 21.5722 14.658C20.6522 14.658 19.9023 13.9081 19.9023 12.9881C19.9024 12.2282 20.4221 11.5885 21.122 11.3885C21.292 11.3485 21.4422 11.2886 21.6122 11.2586Z",
    fill: "#FFF7EB"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRescan);
export default __webpack_public_path__ + "static/media/rescan.040eb597f6e685b137fbdcf0567b0621.svg";
export { ForwardRef as ReactComponent };